import React from "react";
import "./dropdown.css"

const Dropdown = ({data}) => {
  return (
    <div className="pvxDropdown">
      {/* Calender */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
      >
        <path
          d="M13.5 2.25H12.75V1.5C12.75 1.0875 12.4125 0.75 12 0.75C11.5875 0.75 11.25 1.0875 11.25 1.5V2.25H3.75V1.5C3.75 1.0875 3.4125 0.75 3 0.75C2.5875 0.75 2.25 1.0875 2.25 1.5V2.25H1.5C0.675 2.25 0 2.925 0 3.75V15.75C0 16.575 0.675 17.25 1.5 17.25H13.5C14.325 17.25 15 16.575 15 15.75V3.75C15 2.925 14.325 2.25 13.5 2.25ZM12.75 15.75H2.25C1.8375 15.75 1.5 15.4125 1.5 15V6H13.5V15C13.5 15.4125 13.1625 15.75 12.75 15.75Z"
          fill="#6C757D"
        />
      </svg>
      <div className="date">Monthly</div>
      {/* Arrow */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
      >
        <path
          d="M7.0592 8.92489L1.06391 2.07313C0.356709 1.2649 0.930681 0 2.00463 0H13.9952C15.0692 0 15.6431 1.2649 14.9359 2.07313L8.94064 8.92489C8.44263 9.49405 7.55721 9.49405 7.0592 8.92489Z"
          fill="#6C757D"
        />
      </svg>
    </div>
  );
};

export default Dropdown;
